import { ResearchId } from "../../../adapters/insights-agent/state/AppState.ts";
import { useResearchState } from "../../../adapters/insights-agent/state/hooks/stateHooks.ts";
import { useInsightsAgentService } from "../../../adapters/insights-agent/state/hooks/useInsightsAgentService.tsx";
import { RegenerateSummaryButton } from "../../../feature-components/RegenerateSummaryButton/RegenerateSummaryButton.tsx";

interface ConnectedRegenSummaryProps {
  researchId: ResearchId;
}

export const ConnectedRegenSummary = ({
  researchId,
}: ConnectedRegenSummaryProps) => {
  const appService = useInsightsAgentService();
  const research = useResearchState(researchId);
  return (
    <RegenerateSummaryButton
      onClick={() => {
        appService.regenerateSummary({ researchId }).then();
      }}
      disabled={research?.regenerating_summary || false}
    />
  );
};
